import SplitDropdown from './SplitDropdown';

export default SplitDropdown;
